import * as React from 'react';

export default function OptimizelyScript({ optimizelyKey }: { optimizelyKey: string }) {
  return <script id="optimizelyNext" type="text/javascript" src={`https://cdn.optimizely.com/js/${optimizelyKey}.js`} async />;
}
